<template>
  <div id="app" v-touch:right="onSwipeLeft">
    <!-- 头部 -->
    <HeaderTop :show-download="showDownload" @handleClose="showDownload = false" />

    <!-- 左侧导航 -->
    <leftNav v-show="show_left_nav" class="top-right-menu" @ListenChild="tabChange" />

    <!-- 视图窗口 -->
    <router-view id="vier_port" :show-download="showDownload" />

    <!-- 登录弹窗 -->
    <div v-show="is_show_wrap" class="login-wrap" @click="is_show_wrap = false">
      <div v-show="is_show_login" class="login-form" @click.stop="a = 1">
        <!-- <img src="./assets/images/logo/logo.png" class="lr_logo" alt="" /> -->

        <div class="lg-title">
          <div>
            <svg t="1715509209132" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2503" width="20" height="20">
              <path
                d="M512.0181274414062 140.7236328125c-125.93957519531247 0-228.48156738281247 102.50326538085938-228.48156738281247 228.48074340820312 0 125.90167236328126 102.46701049804688 228.44448852539062 228.48156738281247 228.44448852539062 125.97665405273438 0 228.517822265625-102.54199218749999 228.517822265625-228.44448852539062 0-125.97747802734375-102.54116821289061-228.48074340820312-228.517822265625-228.48074340820312z"
                fill="#FFF" p-id="2504" />
              <path
                d="M688.11962890625 592.4355773925781c-48.68206787109375 38.48208618164063-109.30682373046875 62.32461547851563-176.10150146484375 62.32461547851563-66.79550170898438 0-127.38153076171872-23.915863037109375-176.17565917968753-62.32461547851563C243.4666748046875 651.2484130859374 179.14804077148432 754.5303344726562 170.31338500976562 874.1483764648438c32.343475341796875 4.396728515625001 89.89892578124999 9.127990722656248 172.03436279296875 9.127990722656248h339.1916198730469c82.17333984375 0 139.7650451660156-4.731262207031249 172.14724731445312-9.127990722656248-8.762145996093748-119.69384765625-73.07995605468749-222.89996337890622-165.5669860839844-281.71279907226557z"
                fill="#FFF" p-id="2505" />
            </svg>
          </div>

          Login
        </div>

        <div class="item mt">
          <span class="icon">
            <van-icon name="user" class="ricon" />
          </span>
          <span v-show="data.username.length == 0" class="inputno">*</span>
          <input v-model.trim="data.username" type="text" class="inp" :placeholder="'Nome de Usuário'">
          <van-icon v-if="data.username.length > 0" name="close" class="pwdeye" @click="data.username = ''" />
        </div>
        <div v-if="data.username.length == 0" class="LRnotice" />
        <div v-else-if="data.username.length < 4 || data.username.length > 16" class="LRnotice">
          4-16 caráter bit, suporte em inglês/números
        </div>
        <div v-else class="LRnotice" />
        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="data.password.length == 0" class="inputno">*</span>
          <input id="password0" v-model.trim="data.password" type="password" class="inp" :placeholder="'Senha'">
          <van-icon v-if="data.password.length > 0" name="close" class="pwdeye" @click="data.password = ''" />
          <van-icon v-if="showPwd[0]" name="eye-o" class="pwdeye colorc" @click="ShowPwd(0)" />
          <van-icon v-else name="closed-eye" class="pwdeye" @click="ShowPwd(0)" />
        </div>
        <div v-if="data.password.length == 0" class="LRnotice" />
        <div v-else-if="data.password.length < 6 || data.password.length > 18" class="LRnotice">
          6-18 caracteres, incluindo pelo menos números ou letras
        </div>
        <div v-else class="LRnotice" />
        <div class="remeber">
          <div class="rem-left">
            <van-checkbox v-model="checked[0]" shape="square" icon-size="16px" checked-color="#04be02" />
            <span>Lembrar Senha</span>
          </div>
          <div class="rem-right">
            Esqueceu a Senha?
          </div>
        </div>

        <div class="lg-btn" @click="submit_login()">
          Login
        </div>

        <div class="loginrow">
          <!-- {{ $t("还没账号?") }} -->
          <span class="signup" @click="toSupport">Suporte</span>
          <!-- <span class="signup">Jogar Grátis</span> -->
          <span class="signup" @click.stop="register()">Registra uma Conta</span>
        </div>
        <div class="loginrow" style="font-weight: 100">
          ——
          <span>Outros métodos de início de sessãos</span>
          ——
        </div>
        <div class="lrgg" @click="googleLogin">
          <img src="./assets/images/common/google.png">
        </div>

        <img src="./assets/images/common/close.png" class="close_btn1" alt="" @click="closeWindow()">
      </div>

      <!-- 注册 -->
      <div v-show="is_show_register" class="login-form" @click.stop="a = 1">
        <!-- <img src="./assets/images/logo/logo.png" class="lr_logo" alt="" /> -->

        <div class="lg-title">
          Registro
        </div>

        <div class="item mt">
          <span class="icon">
            <van-icon name="user" class="ricon" />
          </span>
          <span v-show="register_data.mobile.length == 0" class="inputno">*</span>
          <input v-model.trim="register_data.mobile" type="text" class="inp" :placeholder="'Nome de Usuário'">
        </div>
        <div v-if="register_data.mobile.length == 0" class="LRnotice" />
        <div v-else-if="
          register_data.mobile.length < 5 || register_data.mobile.length > 16
        " class="LRnotice">
          4-16 caráter bit, suporte em inglês/númeross
        </div>
        <div v-else class="LRnotice" />
        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="register_data.password.length == 0" class="inputno">*</span>
          <input id="password1" v-model.trim="register_data.password" type="password" class="inp"
            :placeholder="$t('请设置登录密码')">
          <div v-show="!isShowPwd" style="margin-right: .15rem;" @click="ShowPwd(1)">
            <svg class="showPwd" width="30" height="30" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="icon/ç™»é™†æ³¨å†Œ/è¿”å›žæŒ‰é’®å¤‡ä»½ 2">
                <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                <path id="å½¢çŠ¶ç»“åˆ" fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.779 7.5446C14.6375 6.98232 13.3541 6.66708 12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C4.59664 13.7238 5.63335 15.0587 6.95504 16.0234L8.91771 14.1369C8.56561 13.5709 8.36343 12.8967 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C12.7879 8.50079 13.5105 8.74232 14.1003 9.15736L15.779 7.5446ZM20 12.1671C19.5466 10.9843 18.8392 9.92947 17.9458 9.06782L15.553 11.3677C15.6078 11.6244 15.6366 11.8918 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334C11.6653 15.8334 11.3424 15.7898 11.0364 15.7078L9.41274 17.2687C10.2299 17.5276 11.0993 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671ZM14.1073 12.7577C13.9015 13.5488 13.2865 14.1436 12.4858 14.316L14.1073 12.7577ZM13.011 10.2039C12.7114 10.0518 12.3687 9.96708 12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 12.4999 9.88568 12.8118 10.008 13.0903L13.011 10.2039Z"
                  fill="currentColor" />
                <rect id="çŸ©å½¢_2" x="17.6742" y="6" width="1.5" height="16" rx="0.75" transform="rotate(45 17.6742 6)"
                  fill="" />
              </g>
            </svg>
          </div>
          <div v-show="isShowPwd" style="margin-right: .15rem;" @click="ShowPwd(1)">
            <svg class="showText" width="30" height="30" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="icon/ç™»é™†æ³¨å†Œ/æŸ¥çœ‹å¯†ç&nbsp;">
                <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                <path id="å½¢çŠ¶" fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C5.23657 15.3934 8.36343 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671C18.7634 8.94078 15.6366 6.66708 12 6.66708ZM12 15.8334C9.96342 15.8334 8.36343 14.2197 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C14.0366 8.50079 15.6366 10.1145 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334ZM12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 13.4134 10.7634 14.3671 12 14.3671C13.2366 14.3671 14.1817 13.4134 14.1817 12.1671C14.1817 10.9208 13.2366 9.96708 12 9.96708Z"
                  fill="" />
              </g>
            </svg>
          </div>
          <!-- <van-icon v-show="showPwd[1]" name="eye-o" class="pwdeye" />
          <van-icon v-show="!showPwd[1]" name="closed-eye" class="pwdeye"  /> -->
        </div>
        <div v-if="register_data.password.length == 0" class="LRnotice" />
        <div v-else-if="
          register_data.password.length < 6 ||
          register_data.password.length > 18
        " class="LRnotice">
          A senha tem de 6 a 18 caracteres
        </div>
        <div v-else class="LRnotice" />
        <div class="streng-box">
          <span class="forSpan">Força</span>
          <div class="schedule">
            <span class="bg-span p-a" />
            <span class="bg-span p-b" />
            <span class="bg-span p-c" />
            <span class="bg-span p-d" />
            <span v-if="strength >= 1" class="low p-a" />
            <span v-if="strength >= 2" class="centre p-b" />
            <span v-if="strength >= 3" class="tall p-c" />
            <span v-if="strength >= 3" class="tall p-d" />
            <span class="text">4-16 Dígitos</span>
          </div>

            
        </div>

        <div class="item">
          <span class="icon">
            <van-icon name="lock" class="ricon" />
          </span>
          <span v-show="register_data.spassword.length == 0" class="inputno">*</span>
          <input id="password2" v-model.trim="register_data.spassword" type="password" class="inp"
            :placeholder="$t('重复登录密码')">
          <div v-show="!isShowPwd2" style="margin-right: .15rem;" @click="ShowPwd2(2)">
            <svg class="showPwd" width="30" height="30" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="icon/ç™»é™†æ³¨å†Œ/è¿”å›žæŒ‰é’®å¤‡ä»½ 2">
                <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                <path id="å½¢çŠ¶ç»“åˆ" fill-rule="evenodd" clip-rule="evenodd"
                  d="M15.779 7.5446C14.6375 6.98232 13.3541 6.66708 12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C4.59664 13.7238 5.63335 15.0587 6.95504 16.0234L8.91771 14.1369C8.56561 13.5709 8.36343 12.8967 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C12.7879 8.50079 13.5105 8.74232 14.1003 9.15736L15.779 7.5446ZM20 12.1671C19.5466 10.9843 18.8392 9.92947 17.9458 9.06782L15.553 11.3677C15.6078 11.6244 15.6366 11.8918 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334C11.6653 15.8334 11.3424 15.7898 11.0364 15.7078L9.41274 17.2687C10.2299 17.5276 11.0993 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671ZM14.1073 12.7577C13.9015 13.5488 13.2865 14.1436 12.4858 14.316L14.1073 12.7577ZM13.011 10.2039C12.7114 10.0518 12.3687 9.96708 12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 12.4999 9.88568 12.8118 10.008 13.0903L13.011 10.2039Z"
                  fill="currentColor" />
                <rect id="çŸ©å½¢_2" x="17.6742" y="6" width="1.5" height="16" rx="0.75" transform="rotate(45 17.6742 6)"
                  fill="" />
              </g>
            </svg>
          </div>
          <div v-show="isShowPwd2" style="margin-right: .15rem;" @click="ShowPwd2(2)">
            <svg class="showText" width="30" height="30" viewBox="0 0 24 24" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g id="icon/ç™»é™†æ³¨å†Œ/æŸ¥çœ‹å¯†ç&nbsp;">
                <rect id="çŸ©å½¢" opacity="0.01" width="24" height="24" fill="#D8D8D8" />
                <path id="å½¢çŠ¶" fill-rule="evenodd" clip-rule="evenodd"
                  d="M12 6.66708C8.36343 6.66708 5.23658 8.94078 4 12.1671C5.23657 15.3934 8.36343 17.6671 12 17.6671C15.6366 17.6671 18.7634 15.3934 20 12.1671C18.7634 8.94078 15.6366 6.66708 12 6.66708ZM12 15.8334C9.96342 15.8334 8.36343 14.2197 8.36343 12.1671C8.36343 10.1134 9.96342 8.50079 12 8.50079C14.0366 8.50079 15.6366 10.1145 15.6366 12.1671C15.6366 14.2208 14.0366 15.8334 12 15.8334ZM12 9.96708C10.7634 9.96708 9.81828 10.9208 9.81828 12.1671C9.81828 13.4134 10.7634 14.3671 12 14.3671C13.2366 14.3671 14.1817 13.4134 14.1817 12.1671C14.1817 10.9208 13.2366 9.96708 12 9.96708Z"
                  fill="" />
              </g>
            </svg>
          </div>
          <!-- <van-icon v-show="showPwd[2]" name="eye-o" class="pwdeye" @click="ShowPwd(2)" />
          <van-icon v-show="!showPwd[2]" name="closed-eye" class="pwdeye" @click="ShowPwd(2)" /> -->
        </div>

        <div class="item mt">
          <span class="icon">
            <i class="ricon el-icon-connection" />
          </span>
          <input v-model.trim="register_data.invitation_code" @change="invitation_code_change" type="text" class="inp"
            placeholder="Código de Convite">
        </div>
        <div v-if="!isTrueInvitation_code" class="LRnotice">
          Por favor, insira o código de convite correto.
        </div>
        <div class="item mt">
          <span class="icon">
            <i class="ricon el-icon-postcard" />
          </span>
          <input v-model.trim="register_data.real_name" type="text" class="inp" :placeholder="'Nome completo'">
        </div>

        <div class="remeber2">
          <van-checkbox v-model="checked[1]" shape="square" icon-size="16px" checked-color="#04be02" />
          <span>Tenho 18 anos, li e concordo com </span>
          <span class="colorc"> 《Contrato do usuário》</span>
        </div>

        <div class="now-btn" @click="submit_reigster">
          Registro
        </div>
        <div class="loginrow">
          <span class="signup" @click="toSupport">Suporte</span>
          <!-- <span class="signup">Jogar Grátis</span> -->
          <span class="signup" @click="login()">Login Agora</span>
        </div>
        <div class="loginrow" style="font-weight: 100">
          ——
          <span>Outros métodos de início de sessãos</span>
          ——
        </div>
        <div class="lrgg">
          <img src="./assets/images/common/google.png">
        </div>
        <img src="./assets/images/common/close.png" class="close_btn" alt="" @click="closeWindow()">
      </div>
    </div>
    <!-- 充值页面 -->
    <van-popup v-model="isShowRecharge" position="bottom" style="height: 90%;max-width:456px;left: auto;">
      <recharge />
    </van-popup>
    <div v-show="isShowBottom" :class="isShowRed ? 'bottom_dom red' : 'bottom_dom'" style="padding-bottom: 1rem;">
      <div class="actList">
        <div v-for="(item, index) in activ_list" :ref="`item-${index}`" class="act_item" @click="changeAct(index)">
          <div class="item-img">
            <img :class="act_active == index ? 'active' : ''" :src="getImagePath(index)" alt="">
          </div>
          <p class="act_name">
            {{ item.name }}
          </p>
        </div>
      </div>
    </div>
    <!-- 底部导航 -->
    <div v-show="isShowFt">
      <FtNav />
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Notify, showNotify, Popup } from "vant";
import { Icon, Popover, Checkbox, CheckboxGroup } from "vant";
import router from "./router";
import Fetch from "./utils/fetch";
import FtNav from "./components/footer_nav/footer_nav.vue";
import leftNav from "./components/leftNav.vue";
import HeaderTop from "./components/header.vue";
import recharge from "./views/recharge/recharge.vue";

Vue.use(Notify).use(Icon).use(Popover).use(Checkbox).use(CheckboxGroup).use(Popup);
export default {
  name: "App",
  components: {
    FtNav,
    leftNav,
    HeaderTop,
    recharge
  },
  data() {
    return {
      isShowBottom: false,
      act_active: 0,
      isShowRed: false,
      isShowFt: true,
      isShowRecharge: false,
      checked: [true, true],
      showPwd: [false, false, false],
      user_balance: localStorage.getItem("user_balance") || 0,
      is_show_wrap: false,
      is_show_login: false,
      is_show_register: false,
      sync_timer: null,
      showUserinfo: false,
      showUser: false,
      show_left_nav: false,
      activ_list: [
        {
          name: 'Evento de baú de tesouro de convite'
        },
        {
          name: ''
        },
        {
          name: ''
        },
        {
          name: 'Bónus de apostas PG'
        },
        {

          name: ''
        },
        {
          name: ''

        },
        {
          name: 'Envelope vermelho cronometrado'
        },
      ],
      app: {},
      isShowPwd: false,
      isShowPwd2: false,
      data: {
        username: "",
        password: "",
      },
      register_data: {
        password: "",
        spassword: "",
        mobile: "",
        invitation_code: null,
        sms: "",
        real_name: "",
      },
      isTrueInvitation_code: true
    };
  },
  computed: {
    showDownload() {
      let u = navigator.userAgent;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //判断是否是 iOS终端
      return !isIOS
    },
    strength() {
      //验证密码强度的函数
      var val = this.register_data.password || "";
      var lv = 0;
      if (val.match(/[a-z]/g)) {
        lv++;
      } //验证是否包含字母
      if (val.match(/[0-9]/g)) {
        lv++;
      } // 验证是否包含数字
      if (val.match(/(.[^a-z0-9])/g)) {
        lv++;
      } //验证是否包含字母，数字，字符
      if (val.length > 12) {
        lv++;
      }
      if (lv > 3) {
        lv = 4;
      }
      return lv;
    },
  },
  watch: {
    user_balance: function (newv) {
      localStorage.setItem("user_balance", newv);
    },
    $route: function (r) {

      if (
        r.path == "/subgame" ||
        r.path == "/vip" ||
        r.path == "/share" ||
        r.path == "/gameRecord" ||
        r.path == "/betReward" ||
        r.path == "/rechargeRecord" ||
        r.path == "/withdrawRecord" ||
        r.path == "/record" ||
        r.path == "/setpasswd" ||
        r.path == "/withdraw" ||
        r.path == "/turnTable" ||
        r.path == "/recharge" ||
        r.path == "/centerWallet" ||
        r.path == "/setting" ||
        r.path == '/recente' ||
        r.path == '/activity/red' || r.path == "/agent" || r.path == "/article" || r.path == "/teamList"
      ) {
        this.isShowFt = false;
        // console.log(123,r)
      } else {
        this.isShowFt = true;
      }
      if (r.path == "/activity/red") {
        this.isShowRed = true;
      } else {
        this.isShowRed = false;
      }
      if (r.path == "/article" || r.path == "/agent" || r.path == "/activity/red" || r.path == "/turnTable") {
        if (r.query.index) {
          this.isShowBottom = true
        } else {
          this.isShowBottom = false
        }
      } else {
        this.isShowBottom = false
      }
      console.log(r)
    },
  },
  updated() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  mounted() {
    let _this = this;
    // if (document.documentElement.clientWidth > 900) {
    //   _this.isShowFt = true;
    // }
    // window.onresize = function () {
    //   console.log("宽度", document.documentElement.clientWidth);
    //   console.log("高度", document.documentElement.clientHeight);
    //   if (document.documentElement.clientWidth > 900) {
    //     _this.isShowFt = true;
    //     console.log(_this.isShowFt);
    //   }
    // };
    if (this.register_data.invitation_code !== "") {
      this.$nextTick(() => {
        this.invitation_code_change();
      })
    }
  },
  created() {
    let _this = this;
    router.beforeEach((to, from, next) => {
      let token = localStorage.getItem("token");
      // console.log(router, '参数')
      if (to.fullPath == "/support" || from.fullPath == "/support") {
        return next();
      }
      if (to.redirectedFrom == '/showRegistro') {
        _this.register();
        return false;
      }
      if (!token) {
        _this.login();
        return false;
      }
      return next();
    });
    let param = this.getUrlParams();
    if (param["id"]) {
      if (this.getIdFromUrl()) {
        this.isTrueInvitation_code = true;
        this.register_data.invitation_code = this.getIdFromUrl();
      } else {
        this.isTrueInvitation_code = false
      }
      // if (param["id"].length == 6) {
      //   this.register_data.invitation_code = param["id"];
      // } else {
      //   let idx = param["id"].indexOf("#");
      //   let invi_code = param["id"].substring(0, idx);
      //   this.register_data.invitation_code = invi_code;
      // }
    }
  },
  methods: {
    googleLogin() {
      let url = window.location.href;
      Fetch("/user/thirdLogin", {
        method: 'google',
        return_url: url
      }).then(res => {
        console.log(res)
        if (res.data) {
          window.location.href = res.data;
        }
      })
    },
    invitation_code_change() {
      if (!this.register_data.invitation_code) {
        this.isTrueInvitation_code = true;
        return;
      }

      let code = this.testParma(this.register_data.invitation_code);
      if (code) {
        this.isTrueInvitation_code = true
        this.register_data.invitation_code = code;
      } else {
        this.isTrueInvitation_code = false
      }
    },
    getIdFromUrl() {
      const url = new URL(window.location.href);
      const idParam = url.searchParams.get('id');
      // 检查是否是纯数字
      if (/^\d+$/.test(idParam)) {
        return idParam;
      }
      // 如果不是纯数字，尝试提取第一个%符号前的数字部分
      const match = idParam.match(/^(\d+)(?=[^a-zA-Z0-9]|$)/);
      console.log(match, '23232323')
      if (match && match[1]) {
        return match[1];
      }

      return null; // 如果都不匹配，返回null
    },
    testParma(data) {
      // 检查是否是纯数字
      if (/^\d+$/.test(data)) {
        return data;
      }
      // 如果不是纯数字，尝试提取第一个%符号前的数字部分
      const match = data.match(/^(\d+)(?=[^a-zA-Z0-9]|$)/);
      console.log(match, '23232323')
      if (match && match[1]) {
        return match[1];
      }

      return null; // 如果都不匹配，返回null
    },
    getImagePath(index) {
      return require(`@/assets/images/act/${index + 1}.png`);
    },
    changeAct(index) {
      console.log(123123)
      this.act_active = index;
      if (index == 0) {
        this.$router.push({
          path: "/agent",
          query: { index: index },
        });
      } else if (index == 2) {
        this.$router.push({
          path: "/turnTable",
          query: { index: index },
        });
      } else if (index == 6) {
        this.$router.push({
          path: "/activity/red",
          query: { index: index },
        });
      } else {
        this.$router.push({
          path: "/article",
          query: { index: index },
        });
      }
      this.$nextTick(() => {
        const element = this.$refs[`item-${index}`][0];
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      })
    },
    ShowPwd(i) {
      var password = document.getElementById("password" + i);
      if (password.type == "password") {
        password.type = "text";
        this.showPwd[i] = true;
        this.isShowPwd = true
        // this.isShowPwd2 = true
      } else {
        password.type = "password";
        this.showPwd[i] = false;
        this.isShowPwd = false
        // this.isShowPwd2 = false
        //console.log(1);
      }
    },
    ShowPwd2(i) {
      var password = document.getElementById("password" + i);
      if (password.type == "password") {
        password.type = "text";
        this.isShowPwd2 = true
      } else {
        password.type = "password";
        this.isShowPwd2 = false
        //console.log(1);
      }
    },
    toSupport() {
      console.log(123)
      this.is_show_login = false;
      this.is_show_register = false;
      this.$router.push('/support');
    },
    getUrlParams() {
      let url = window.location.href;
      if (url.indexOf("?") == -1) return {};
      // 通过 ? 分割获取后面的参数字符串
      let urlStr = url.split("?")[1];
      // 创建空对象存储参数
      let obj = {};
      // 再通过 & 将每一个参数单独分割出来
      let paramsArr = urlStr.split("&");
      for (let i = 0, len = paramsArr.length; i < len; i++) {
        // 再通过 = 将每一个参数分割为 key:value 的形式
        let arr = paramsArr[i].split("=");
        obj[arr[0]] = arr[1];
      }
      return obj;
    },
    submit_reigster() {
      if (!this.register_data.mobile) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("手机号码不能为空"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      if (
        !this.register_data.password ||
        this.register_data.password.length < 6
      ) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("密码长度为6-18位"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      if (this.register_data.password != this.register_data.spassword) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("两次密码不一致"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      if (!this.isTrueInvitation_code) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: "Por favor, insira o código de convite correto.",
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return false;
      }
      this.register_data["url"] = window.location.href;
      this.register_data.mobile = this.register_data.mobile.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/register", this.register_data)
        .then((res) => {
          //console.log(res);
          if (res.code == 1) {
            //注册成功
            this.$message.success({
              title: this.$store.state.config.site_name,
              message: this.$t("注册成功"),
              center: true,
              showClose: true,
              offset: 300,
            });
            localStorage.setItem("login_username", this.register_data.mobile);
            localStorage.setItem("token", res.data?.userinfo?.token);
            localStorage.setItem("user_balance", 0);
            //保存账户密码
            localStorage.setItem("login_password", this.register_data.password);
            // fbq("track", "Purchase", { value: "0.00", currency: "USD" })
            setTimeout(() => {
              window.location.reload()
            }, 300);
            // setTimeout(() => {
            //   this.login();
            // }, 3000);
          } else {
            this.$message({
              title: this.$store.state.config.site_name,
              message: res.msg,
              type: "error",
              center: true,
              showClose: true,
              offset: 300,
            });
          }
        })
        .catch((e) => {
          this.$message({
            title: this.$store.state.config.site_name,
            message: this.$t("系统繁忙,请稍后再尝试"),
            type: "error",
            center: true,
            showClose: true,
            offset: 300,
          });
          return false;
        });
    },
    submit_login() {
      if (!this.data.username) {
        this.$message({
          title: this.$store.state.config.site_name,
          message: this.$t("请输入正确的手机号码"),
          type: "error",
          center: true,
          showClose: true,
          offset: 300,
        });
        return;
      }
      if (!this.data.password) {
        this.$message({
          title: this.$store.state.config.site_name,
          type: "error",
          message: this.$t("密码为6-18位"),
          center: true,
          showClose: true,
          offset: 300,
        });
        return;
      }
      this.data.username = this.data.username.replace(
        new RegExp("[+]", "gm"),
        ""
      );
      Fetch("/user/login", {
        account: this.data.username,
        password: this.data.password,
        url: window.location.href
      }).then((res) => {
        //登录失败
        if (res.code == 0) {
          this.$message({
            title: this.$store.state.config.site_name,
            type: "error",
            message: res.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
        } else {
          if (res.data.userinfo.token) {
            localStorage.setItem("token", res.data.userinfo.token);
            localStorage.setItem("user_balance", res.data.userinfo.money);
          }
          this.$message.success({
            title: this.$store.state.config.site_name,
            message: this.$t("登录成功"),
            center: true,
            showClose: true,
            offset: 300,
          });
          //保存账户密码
          localStorage.setItem("login_username", this.data.username);
          localStorage.setItem("login_password", this.data.password);
          //跳转到首页
          setTimeout(() => {
            // window.location.href = "/";
            // window.location.href = "/"+'?time='+((new Date()).getTime());
            // this.$router.go(0);
            window.location.reload()
          }, 400);
        }
      });
    },
    login() {
      this.data.username = localStorage.getItem("login_username")
        ? localStorage.getItem("login_username")
        : "";
      this.is_show_wrap = true;
      this.is_show_login = true;
      this.is_show_register = false;
      return;
    },
    register() {
      this.is_show_wrap = true;
      this.is_show_login = false;
      this.is_show_register = true;
      return;
    },
    closeWindow() {
      this.is_show_wrap = false;
      this.is_show_login = false;
      this.is_show_register = false;
    },
    tabChange(v) {
      // console.log(v);
      this.nav_active = v;
      if (v == 0) {
        this.getGameList();
      }

      if (v == 1) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "PG") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "PG Slots",
          game_list: allGames,
        });
      }
      if (v == 2) {
        this.all_game_list = [];
        let allGames = [];
        this.all_game_list_bak.forEach((item) => {
          item.game_list.forEach((game) => {
            if (game.origin == "TADA") {
              allGames.push(game);
            }
          });
        });
        this.all_game_list.push({
          origin: "TADA Slots",
          game_list: allGames,
        });
      }
      if (v == 3) {
        let localGames = localStorage.getItem("local_game_list");
        if (!localGames) {
          let json_obj = { PG: [], JDB: [], TADA: [] };
          localStorage.setItem("local_game_list", JSON.stringify(json_obj));
          localGames = localStorage.getItem("local_game_list");
        }
        Fetch("/Game/getGameById", JSON.parse(localGames)).then((res) => {
          let _this = this;
          this.all_game_list = res.data;
          this.all_game_list_bak = res.data;
          this.max_show_array = [];
          res.data.forEach(() => {
            _this.max_show_array.push(6);
          });
        });
      }
    },

    changeBalance(val) {
      this.user_balance = val;
    },
    onSwipeLeft(even, start, end) {
      //console.log(window.location.href);

      if (window.location.href.indexOf("signature")) {
        return false;
      }
      if (end["X"] - start["X"] > 60) {
        this.$router.go(-1);
      }
    },
    bigNumeber(str) {
      var str = str.toString();
      var strs = str.split(".");
      var s1 = strs[0] || 0;
      var s2 = strs[1] || "00";
      return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
    },
  },
};
</script>
<style lang="less">
@import "./assets/css/login&register.less";
@import "./assets/css/phone.css";
@import "./assets/css/pad.css";
@import "./assets/css/pc.less";
@import "./assets/css/default.less";
@import "./assets/css/variables.less";

@headerHeight: 1.2rem;

html,
body {
  // width: 100%;
  // height: 100%;
  overflow-y: scroll;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Segoe UI, Arial, Roboto, PingFang SC, miui, Hiragino Sans GB,
    Microsoft Yahei, sans-serif !important;
  user-select: none !important;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  width: 0;
  height: 0;
}

html {
  background-color: @third-color;
}

body {
  max-width: @maxWidth;
  height: 100vh;
  margin: 0 auto !important;
  position: relative;
  // overflow: hidden;
}

/deep/ .el-notification__group {
  color: red !important;
}

.red {
  background-color: #b10b10;
}

/deep/ .van-popup {
  max-width: 456px !important;
}

#app {
  min-height: 100%;
  height: auto;
  width: 100%;
  overflow-x: hidden;
  // background-image: url("./assets/images/index/bg_pattern_tile.webp");
  background-color: @secondary-color;
}

.el-message-box__header {
  background-image: url("./assets/images/logo/v5.png");
  background-repeat: no-repeat;
  background-size: 60%;
  background-position: center;
  height: 0.5rem;
  width: 1.5rem;
  margin: auto;
}

.el-picker-panel {
  z-index: 9999 !important;
}

.el-message--warning {
  z-index: 100000 !important;
}

.lrgg img {
  width: 0.5rem;
  height: 0.5rem;
  padding: 0.2rem;
  background: #fff;
  border-radius: 50%;
}

.bottom_dom {
  // padding: .2rem .2rem 1.4rem .2rem;
  color: #fff;
  width: 100%;
  overflow-x: scroll;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;

  .actList {
    display: flex;
    overflow: auto;
    // width: -moz-max-content;
    width: max-content;

    .act_item {
      width: 3rem;
      min-height: 1.4rem;
      display: flex;
      flex-direction: column;
      flex-shrink: 0;
      margin-right: .2rem;
      cursor: pointer;

      .item-img {
        padding: .04rem;
        height: 1.4rem;
        position: relative;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 100%;
        }

        .active {
          border: 0.05rem solid @anttextcolor;
        }
      }


      .act_name {
        font-size: .3rem;
        margin-top: .04rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
        width: 100%;
        color: @anttextcolor;
      }
    }

  }
}
</style>
